import React from 'react'
import { getApiHost } from '../../../../Api/Utils/apiUtils';
import './SupplierAvatar.css'

const SupplierAvatar = ({avatar}) => {
    return (
        <div className="supplier-avatar">
            <img src={`${getApiHost()}/${avatar}`} alt="supplier" />
        </div>
    )
}

export default SupplierAvatar
